import * as ProfileActions from '../actions/profile.actions';

const INITIAL_STATE = {
  entities: {},
  ids: [],
  isLoading: false,
  loadingById: {},
  roles: [],
  pathSuccess: null,
  msg: null,
};

export default function profile(state = INITIAL_STATE, action = '') {
  switch (action.type) {
    case ProfileActions.LOAD_PROFILE:
    case ProfileActions.CREATE:
      return {
        ...state,
        isLoading: true,
        msg: null,
      };

    case ProfileActions.LOAD_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: action.data.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {}),
        ids: action.data.map((x) => x.id),
        pathSuccess: null,
        msg: null,
      };
    case ProfileActions.UPDATE_ONE:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.data.id]: true,
        },
      };

    case ProfileActions.UPDATE_ONE_SUCCESS:
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.data.id]: {
            ...state.entities[action.data.id],
            ...action.data,
          },
        },
        loadingById: {
          ...state.loadingById,
          [action.data.id]: false,
        },
        // pathSuccess: `/dashboard/profile/list`,
        // msg: { msg: 'Actualizado', status: 'success' }
      };

    case ProfileActions.UPDATE_ONE_FAILED:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.PerfilId]: false,
        },
        msg: { msg: action.error, status: 'warning' },
      };

    case ProfileActions.CREATE_SUCCESS:
      // ids: action.datas.map(x => x.id)
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.data.id]: {
            ...state.entities[action.data.id],
            ...action.data,
          },
        },
        // ids: [...state.ids, action.data.id],
        ids: [...state.ids.filter((x) => x !== action.data.id), action.data.id],
        isLoading: false,
        // pathSuccess: null,
        // msg: { msg: 'Añadido', status: 'success' }
      };
    case ProfileActions.CREATE_SUCCESS_MESSAGE:
      return {
        ...state,
        isLoading: false,
        // msg: { msg: 'Añadido', status: 'success' }
      };
    case ProfileActions.CREATE_FAILED:
      return {
        ...state,
        isLoading: false,
        msg: { msg: action.error, status: 'warning' },
      };

    case ProfileActions.DELETE_SUCCESS:
      delete state.entities[action.data.profileId];
      // delete state.ids[action.data.profileId];

      return {
        ...state,
        entities: {
          ...state.entities,
        },
        ids: state.ids.filter((profileId) => profileId !== action.data.profileId),
        /*  ids: [
          ...state.ids, 
          // action.data.id
        ] */
      };

    default:
      return state;
  }
}

export const getProfileEntities = (state) => state.profiles.entities;
export const getData = (state) => state.profiles.ids.map((id) => state.profiles.entities[id]);
export const getProfileById = (state, id) => state.profiles.entities[id];
export const getPath = (state) => state.profiles.pathSuccess;
export const getIsLoading = (state) => state.profiles.isLoading;
export const getMessage = (state) => state.profiles.msg;
// export const getRoles = state => state.profile.roles
